export enum ComplianceRatingEnum {
  EUDR_COMPLIANT = 'EUDR_COMPLIANT',
  EUDR_NON_COMPLIANT = 'EUDR_NON_COMPLIANT'
}
